import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { DatatableComponent } from '@swimlane/ngx-datatable';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.css']
})
export class ErrorPageComponent implements OnInit, OnDestroy {
  @ViewChild('tableErrors') tableErrors: DatatableComponent;

  errors: any[] = [];
  showErrors = false;

  private subscription;
  private subscription_change;

  constructor(private translateService: TranslateService,
              private activatedRoute: ActivatedRoute) {


  }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      const error: string = params['message'];
      if (error) {
        this.errors = error.split('|').map(err => {
          return { nameError: err };
        });
      }
    });
  }

  onResized(): void {
    if (this.tableErrors) {
      setTimeout(() => {
        this.tableErrors.recalculate();
        window.dispatchEvent(new Event('resize'));
      }, (50));
    }
  }

  toggleShowErrors() {
    this.showErrors = !this.showErrors;
   }

  ngOnDestroy() {
    if (this.subscription != null) { this.subscription.unsubscribe(); }
    if (this.subscription_change != null) { this.subscription_change.unsubscribe(); }
    this.translateService = null;
  }

}
